module.exports = __webpack_public_path__ + "img/love-balloon.012aa82a.png";